/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, pct: NonNullable<unknown> }} Native_Release_Widget_Recovery_MuscleInputs */

const en_us2_native_release_widget_recovery_muscle = /** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · ${i?.pct}%`)
};

const pt_br2_native_release_widget_recovery_muscle = /** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · ${i?.pct}%`)
};

const pt_pt2_native_release_widget_recovery_muscle = /** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · ${i?.pct}%`)
};

/** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */
const es_419_native_release_widget_recovery_muscle = en_us2_native_release_widget_recovery_muscle;

/** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */
const fr_fr2_native_release_widget_recovery_muscle = en_us2_native_release_widget_recovery_muscle;

/** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */
const de_de2_native_release_widget_recovery_muscle = en_us2_native_release_widget_recovery_muscle;

/** @type {(inputs: Native_Release_Widget_Recovery_MuscleInputs) => LocalizedString} */
const it_it2_native_release_widget_recovery_muscle = en_us2_native_release_widget_recovery_muscle;

/**
* | output |
* | --- |
* | "{name} · {pct}%" |
*
* @param {Native_Release_Widget_Recovery_MuscleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_recovery_muscle = /** @type {((inputs: Native_Release_Widget_Recovery_MuscleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Recovery_MuscleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_recovery_muscle(inputs)
	if (locale === "es-419") return es_419_native_release_widget_recovery_muscle(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_recovery_muscle(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_recovery_muscle(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_recovery_muscle(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_recovery_muscle(inputs)
	return en_us2_native_release_widget_recovery_muscle(inputs)
});
export { native_release_widget_recovery_muscle as "native-release.widget_recovery_muscle" }